export { default as ProductsElasticSearchCustomTagsFilterBadgesItem } from './ProductsElasticSearchCustomTagsFilterBadgesItem';
